__turbopack_context__.v({
  "app-header__container": "_9XBSdW_app-header__container",
  "app-header__cta": "_9XBSdW_app-header__cta",
  "app-header__cta--mobile": "_9XBSdW_app-header__cta--mobile",
  "app-header__menu-item": "_9XBSdW_app-header__menu-item",
  "app-header__platform-name": "_9XBSdW_app-header__platform-name",
  "app-header__submenu": "_9XBSdW_app-header__submenu",
  "app-header__submenu__icon": "_9XBSdW_app-header__submenu__icon",
  "app-header__submenu__item": "_9XBSdW_app-header__submenu__item",
});
